module.exports = __webpack_public_path__ + "static/media/res9.ffb2d087.PNG";